import {Component, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {EditContractPage} from '../edit-contract/edit-contract.page';
import {ActivatedRoute} from '@angular/router';
import {DataStore} from '@aws-amplify/datastore';
import {Bonus, Contract} from '../../models';
import {S3LinkPipe} from "../pipes/s3-link.pipe";
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {

  contractId;
    currentContract;
    bonusContact;

    constructor(
        private route: ActivatedRoute,
        private navController: NavController,
        private modalController: ModalController,
        private s3LinkPipe: S3LinkPipe,
        public sessionService: SessionService,
    ) {

    }

    async ngOnInit() {
        await this.route.params.subscribe(params => {
            this.contractId = params['paymentId'];
        });

        this.refreshContract();
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    private async refreshContract() {
        this.currentContract = await DataStore.query(Bonus, this.contractId);
        this.bonusContact = await DataStore.query(Contract, this.currentContract.contractId);
    }

    back() {
        this.navController.back();
    }

    open(file: any) {
        
        window.open(this.s3LinkPipe.transform(file), '_system');
    }

    openPage(s: string) {
        
    }
}
